import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function MerchantPrinter() {
    const [rows, setRows] = useState([]);
    const [preview, setPreview] = useState(null);
    useEffect(() => { api.get("/merchant/print/jobs").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);
    return (
        <div>
            <h1 className="text-2xl font-bold">Print Queue</h1>
            <p className="text-sm text-muted-foreground mt-1">Last 50 print jobs (KOT / Bill)</p>
            <div className="mt-6 bg-card border border-border rounded-2xl overflow-x-auto">
                <table className="w-full text-sm">
                    <thead><tr className="bg-muted/60 text-left text-[11px] uppercase tracking-wider"><th className="px-4 py-3">Time</th><th className="px-4 py-3">Order</th><th className="px-4 py-3">Kind</th><th className="px-4 py-3">Status</th><th className="px-4 py-3"></th></tr></thead>
                    <tbody>
                        {rows.map((j) => (
                            <tr key={j.id} className="border-t border-border" data-testid={`pj-${j.id}`}>
                                <td className="px-4 py-3 font-mono text-xs">{new Date(j.created_at).toLocaleTimeString()}</td>
                                <td className="px-4 py-3 font-semibold">{j.order_id?.slice(0, 8)}…</td>
                                <td className="px-4 py-3">{j.job_kind}</td>
                                <td className="px-4 py-3"><span className={`text-[10px] uppercase tracking-wider font-bold px-2 py-1 rounded-full ${j.status === "PRINTED" ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>{j.status}</span></td>
                                <td className="px-4 py-3"><button onClick={() => setPreview(j)} className="text-xs font-semibold text-primary">View</button></td>
                            </tr>
                        ))}
                        {rows.length === 0 && <tr><td colSpan={5} className="text-center py-12 text-muted-foreground">No print jobs yet. Print a KOT or Bill from the Orders screen.</td></tr>}
                    </tbody>
                </table>
            </div>
            {preview && (
                <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" onClick={() => setPreview(null)}>
                    <pre className="bg-white text-black rounded-xl p-4 font-mono text-xs whitespace-pre max-w-md w-full" onClick={(e) => e.stopPropagation()}>{preview.content}</pre>
                </div>
            )}
        </div>
    );
}
